module.exports = __webpack_public_path__ + "static/forecast/weather/nightmodrain-9d7df92949bcf86c6e9ce465fc0411b0.svg";